import { render, staticRenderFns } from "./MixItemListTwoCol.vue?vue&type=template&id=480ed1f1&scoped=true&"
import script from "./MixItemListTwoCol.vue?vue&type=script&lang=js&"
export * from "./MixItemListTwoCol.vue?vue&type=script&lang=js&"
import style0 from "./MixItemListTwoCol.vue?vue&type=style&index=0&id=480ed1f1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "480ed1f1",
  null
  
)

export default component.exports